import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import authTranslationEN from "./auth/src/locales/en/translation.json";
import authTranslationKO from "./auth/src/locales/ko/translation.json";
import authTranslationZh from "./auth/src/locales/zh/translation.json";

import registrationTranslationEN from "./streamlineregistration/src/locales/en/translation.json";
import registrationTranslationKO from "./streamlineregistration/src/locales/ko/translation.json";
import registrationTranslationZh from "./streamlineregistration/src/locales/zh/translation.json";

import forgetPasswordSendEmailTranslationEN from "./forgetpasswordsendemail/src/locales/en/translation.json";
import forgetPasswordSendEmailTranslationKO from "./forgetpasswordsendemail/src/locales/ko/translation.json";
import forgetPasswordSendEmailTranslationZh from "./forgetpasswordsendemail/src/locales/zh/translation.json";

import commonTranslationEN from "./common/locales/en/translation.json";
import commonTranslationKO from "./common/locales/ko/translation.json";
import commonTranslationZh from "./common/locales/zh/translation.json";

import accountStatusTranslationEN from "./accountstatus/locales/en/translation.json";
import accountStatusTranslationKO from "./accountstatus/locales/ko/translation.json";
import accountStatusTranslationZh from "./accountstatus/locales/zh/translation.json";

// the translations
const resources = {
  en: {
    translation: {
      auth: authTranslationEN,
      registration: registrationTranslationEN,
      forgetPasswordSendEmail: forgetPasswordSendEmailTranslationEN,
      common: commonTranslationEN,
      accountstatus: accountStatusTranslationEN,
    },
  },
  ko: {
    translation: {
      auth: authTranslationKO,
      registration: registrationTranslationKO,
      forgetPasswordSendEmail: forgetPasswordSendEmailTranslationKO,
      common: commonTranslationKO,
      accountstatus: accountStatusTranslationKO,
    },
  },
  zh: {
    translation: {
      auth: authTranslationZh,
      registration: registrationTranslationZh,
      forgetPasswordSendEmail: forgetPasswordSendEmailTranslationZh,
      common: commonTranslationZh,
      accountstatus: accountStatusTranslationZh,
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: false,
    resources,
    lng: localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources, // language to use
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
